import { useUpdatePropNew } from 'client/components/core/Sidebar/components/Settings/hooks/useUpdateProps'
import { useAppDispatch } from 'client/hooks/use-dispatch'
import { setSettingsEditing } from 'client/store/management/managementActions'
import React, { useLayoutEffect } from 'react'
import { GroupTitle } from 'src/editor/layout/sidebar/settings/group-title'
import { ColorPickerControl } from 'src/editor/shared/settings/controls/color-picker/color-picker-control'
import { TextAreaControl } from 'src/editor/shared/settings/controls/text-area-control'
import { TextInputControl } from 'src/editor/shared/settings/controls/text-input-control'
import { FormInterface } from 'src/shared/entities/form/form.schema'

interface FormDesignSettingsProps {
  entity: FormInterface
}

export const SuccessOptInScreenSettings = ({
  entity,
}: FormDesignSettingsProps) => {
  const dispatch = useAppDispatch()

  const updateProp = useUpdatePropNew(entity)

  useLayoutEffect(() => {
    dispatch(
      setSettingsEditing({
        id: entity.id,
        type: entity.type,
        areSuccessOptInScreenSettingsOpened: true,
      }),
    )
    return () => {
      dispatch(
        setSettingsEditing({
          id: entity.id,
          type: entity.type,
          areSuccessOptInScreenSettingsOpened: false,
        }),
      )
    }
  }, [])

  return (
    <>
      <TextInputControl
        value={entity.action.successOptInScreen?.headingText}
        update={updateProp('action', 'successOptInScreen', 'headingText')}
        wrapperProps={{
          labelText: 'entity_settings.form.success_opt_in_screen.heading_text',
        }}
      />
      <TextAreaControl
        value={entity.action.successOptInScreen?.text}
        update={updateProp('action', 'successOptInScreen', 'text')}
        wrapperProps={{
          labelText: 'entity_settings.form.success_opt_in_screen.label',
        }}
      />
      <GroupTitle>website_styles_settings.colors.label</GroupTitle>
      <ColorPickerControl
        label="text color"
        update={updateProp('action', 'successOptInScreen', 'textColor')}
        mobileUpdate={updateProp(
          'action',
          'successOptInScreen',
          'mobileTextColor',
        )}
        color={
          entity.action.successOptInScreen?.textColor ||
          entity.fieldsCommonStyles.color
        }
        mobileColor={entity.action.successOptInScreen?.mobileTextColor}
        isClearable
      />
      <ColorPickerControl
        label="icon color"
        update={updateProp('action', 'successOptInScreen', 'iconColor')}
        mobileUpdate={updateProp(
          'action',
          'successOptInScreen',
          'mobileIconColor',
        )}
        color={entity.action.successOptInScreen?.iconColor}
        mobileColor={entity.action.successOptInScreen?.mobileIconColor}
      />
      <ColorPickerControl
        label="background color"
        update={updateProp('action', 'successOptInScreen', 'backgroundColor')}
        mobileUpdate={updateProp(
          'action',
          'successOptInScreen',
          'mobileBackgroundColor',
        )}
        color={
          entity.action.successOptInScreen?.backgroundColor ||
          entity.backgroundColor
        }
        mobileColor={entity.action.successOptInScreen?.mobileBackgroundColor}
        isClearable
      />
    </>
  )
}
